var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-table',{attrs:{"bordered":"","loading":_vm.loading,"columns":_vm.columns,"data-source":_vm.recordList,"pagination":_vm.pagination,"scroll":{ x: 1100 }},on:{"change":_vm.handleTableChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }